import { render, staticRenderFns } from "./ArticleSecondSkeleton.vue?vue&type=template&id=3de8e55c&scoped=true&"
import script from "./ArticleSecondSkeleton.vue?vue&type=script&lang=js&"
export * from "./ArticleSecondSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ArticleSecondSkeleton.vue?vue&type=style&index=0&id=3de8e55c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de8e55c",
  null
  
)

export default component.exports